/** The unauthenticated tier: landing and legal pages rendered without AuthProvider, so a
 * stranger is never redirected. A visitor who already has a session and lands on / goes to
 * the app; on a legal page they stay. */
import { useEffect } from "react";
import { navigate } from "../app/router";
import { brand } from "../brand";
import type { AppConfig } from "../config";
import "../styles/site.css";
import { Footer } from "./Footer";
import { Landing } from "./Landing";
import { Privacy } from "./Privacy";
import { Rights } from "./Rights";
import { hasSession } from "./session";
import { Terms } from "./Terms";

export const PUBLIC_ROUTES = ["/", "/terms", "/privacy", "/rights"] as const;
export const HOME = "/subjects";

export function Site({ cfg, route }: { cfg: AppConfig; route: string }) {
  useEffect(() => {
    if (route !== "/") return;
    let live = true;
    void hasSession(cfg).then((yes) => live && yes && navigate(HOME));
    return () => {
      live = false;
    };
  }, [cfg, route]);
  const signIn = () => navigate(HOME); // AuthProvider takes it from here: no session → hosted login
  return (
    <div className="site">
      {/* The landing carries its own nav on the room; the legal pages keep the paper bar. */}
      {route !== "/" && (
        <header className="bar">
          <a
            className="wordmark"
            href="/"
            onClick={(e) => {
              e.preventDefault();
              navigate("/");
            }}
          >
            {brand.wordmark}
          </a>
          <nav>
            <a
              href={HOME}
              onClick={(e) => {
                e.preventDefault();
                signIn();
              }}
            >
              Sign in
            </a>
          </nav>
        </header>
      )}
      {route === "/" ? (
        <Landing trialOpen={cfg.trialOpen} onSignIn={signIn} />
      ) : route === "/terms" ? (
        <Terms />
      ) : route === "/privacy" ? (
        <Privacy />
      ) : (
        <Rights />
      )}
      <Footer />
    </div>
  );
}
